module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_2.e42a1925.png";